/* global window, document */
const getVehiclePicker = () => import(/* webpackChunkName: "get-vehicle-picker" */ 'public/js/components/vehicle-picker.js');

// A list of classes used to open the vehicle picker
const vehiclePickerSelectors = [
	'.vehiclepicker_classic',
	'.vehiclepicker',
	'.vehiclepicker_link',
	'.vehiclepicker-link',
];

const handleOpenVehiclePicker = ({ currentTarget }, props = null) => {
	const pickerData = props || currentTarget.dataset;
	//dynamically import the vehicle picker class
	getVehiclePicker().then((module) => {
		module.getDataAndOpenVehiclePicker(pickerData);
	});
};

/* Call vehicle picker on select elements
.*-----------------------------------------*/
document.querySelectorAll(vehiclePickerSelectors.join(', ')).forEach((elem) => {
	elem.addEventListener('click', handleOpenVehiclePicker);
});

//Moved this out from the vehicle picker js file to account for scenarios where this is called from custom html modules
window.openVehiclePicker = window.openVehiclePickerRedirect = (make, model, year, trim, engine, redirect) => {
	handleOpenVehiclePicker({}, {make, model, year, trim, engine, redirect});
};